import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './index.scss';

import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import Routing from './Routing';
import SocketProvider from './context/SocketProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// ✅ Add Zoom Shortcuts Here
function GlobalZoomHandler() {
  useEffect(() => {
    let zoom = 1;

    const handleKeyDown = (e) => {
      // Ctrl + +
      if (e.ctrlKey && (e.key === "+" || e.key === "=")) {
        zoom += 0.1;
        document.body.style.zoom = zoom;
      }

      // Ctrl + -
      if (e.ctrlKey && e.key === "-") {
        zoom -= 0.1;
        if (zoom < 0.5) zoom = 0.5;
        document.body.style.zoom = zoom;
      }

      // Ctrl + 0 → Reset zoom
      if (e.ctrlKey && e.key === "0") {
        zoom = 1;
        document.body.style.zoom = zoom;
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return null; 
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    {/* ⬇ Global Zoom Component Added */}
    <GlobalZoomHandler />

    <Provider store={store}>
      <ToastContainer />
      <SocketProvider>
        <Routing />
      </SocketProvider>
    </Provider>
  </>
);

reportWebVitals();
